import Table from "components/Table/Table";
import ProductRow from "./ProductRow";
import { useTranslation } from "react-i18next";
import scss from "./CheckoutTable.module.scss";

const CheckoutTable = ({ items, translateKey }) => {
    const { t } = useTranslation();

    return (
        <div className={scss.tableWrap}>
            <Table>
                <thead>
                    <tr>
                        <th className={scss.tcCode}>{t(`${translateKey}-code`)}</th>
                        <th className={scss.tcTitle}>{t(`${translateKey}-title`)}</th>
                        <th>{t(`${translateKey}-base_price`)}</th>
                        <th>{t(`${translateKey}-rebate`)}</th>
                        <th>{t(`${translateKey}-discount`)}</th>
                        <th>{t(`${translateKey}-price_excluding_vat`)}</th>
                        <th className={scss.tcInt}>{t(`${translateKey}-quantity`)}</th>
                        <th>{t(`${translateKey}-total_excluding_vat`)}</th>
                        <th className={scss.tcActions} aria-label={t("global-default-text-Actions", { defaultValue: "Akcije" })} />
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => (
                        <ProductRow key={`${item?.product?.id}_CheckoutTable`} item={item} translateKey={translateKey} />
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default CheckoutTable;
